<template>
  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4" v-if="integrationId==1">
    <input-text-checkbox :fieldDataCheckbox="fieldDataCheckbox" :fieldDataText="fieldDataText" :key="fieldDataCheckbox.field_name" :defaultTextValue="defaultTextValue"></input-text-checkbox>
  </div>
  <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4" v-else>
    <input-checkbox :fieldData="fieldDataCheckbox" :key="fieldDataCheckbox.field_name"></input-checkbox>
  </div>
</template>

<script>
/* eslint-disable */
import InputCheckbox from '../../interactive/InputCheckbox';
import InputTextCheckbox from '../../interactive/InputCheckboxText';

export default {
  components: { InputCheckbox, InputTextCheckbox },
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['platformState', 'integrationId', 'productId', 'customLabel', 'integrationPlatform'],
  data() {
    return {
      fieldDataCheckbox: {},
      fieldDataText: {},
    };
  },
  computed: {
    fieldName() {
      return `productId_${this.productId}_integrationId_${this.integrationId}_${this.platformState.stateCd}`;
    },
    defaultTextValue() {
      return (this.integrationPlatform ? this.integrationPlatform.defaultExternalCarrierId : '');
    },
  },
  methods: {
    /**
     * The InputCheckbox only accepts the common `fieldData` object. This Carrier Manager flow, though, uses a different object structure.
     *
     * To set the parent object's property `isActive`, the `field_value` is watched for change and updates the parent property with that value.
     * It is similar to two-way binding but without `emit`.
     *
     * `platformState.isActive` (Carrier Manager property) === `fieldData.field_value` (interactive component's object property)
     */
    setFieldData() {
      this.fieldDataCheckbox = {
        label: this.platformState.stateName +'('+ this.platformState.stateCd +')',
        field_type: 'checkbox',
        field_name: `${this.fieldName}_checkbox`,
        is_required: false,
        field_value: this.platformState.isActive,
        field_validation_rules: '',
        is_enabled: this.platformState.isCheckboxEnabled,
        visible: true,
        max_length: 50,
      };

      this.fieldDataText = {
        label: '',
        field_type: 'text',
        field_name: `${this.fieldName}_text`,
        is_required: false,
        field_value: this.platformState.externalCarrierId,
        field_validation_rules: '',
        is_enabled: this.platformState.isTextEnabled,
        visible: true,
        max_length: 50,
      };
    },
  },
  mounted() {
    this.setFieldData();
  },
  watch: {
    // Updates parent property since no two-way binding in Vue and the parent object can't be passed to the InputCheckbox component.
    'fieldDataCheckbox.field_value': function fieldDataCheckboxFieldValue(newValue) {
      this.platformState.isActive = newValue;
    },
    // Updates parent property since no two-way binding in Vue and the parent object can't be passed to the InputCheckbox component.
    'fieldDataText.field_value': function fieldDataTextFieldValue(newValue) {
      this.platformState.externalCarrierId = newValue;
    },
    // Updates child property since the `fieldDataText` object is only set upon `mounted` lifecycle.
    'platformState.externalCarrierId': function platformStateExternalCarrierId(newValue) {
      this.fieldDataText.field_value = newValue;
    },
    // Updates child property since the `fieldDataCheckbox` object is only set upon `mounted` lifecycle.
    'platformState.isActive': function platformStateIsActive(newValue) {
      this.fieldDataCheckbox.field_value = newValue;
    },
    // Updates child property since the `fieldDataCheckbox` object is only set upon `mounted` lifecycle.
    'platformState.isCheckboxEnabled': function platformStateIsCheckboxEnabled(newValue) {
      this.fieldDataCheckbox.is_enabled = newValue;
    },
  },
};
</script>

<style scoped lang="scss">
.input-elements {
  .field-input-text {
    .input-group {
      width: 100% !important;
    }

    label {
      display: none;
    }
  }

  .form-group {
    margin-bottom: 0;
  }

  &.read-only-id label {
    font-weight: normal;
  }
}
.custom-control-input:checked ~ .custom-control-label::before{
  background-color: #333333 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/carriers/stateIntegration/CarrierPlatformState.vue?1c4ea83a